import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

export default function Embed() {
  const rootElement = ReactDOM.createRoot(document.getElementById('root_element'));

  rootElement.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
